<div class="rot-overlay" *ngIf="visible">
    <div class="rot-line rot-line--v rot-line--v1"></div>
    <div class="rot-line rot-line--v rot-line--v2"></div>
    <div class="rot-line rot-line--h rot-line--h1"></div>
    <div class="rot-line rot-line--h rot-line--h2"></div>
</div>
